<template>
  <footer
    class="d-flex flex-column justify-content-center w-100 text-center py-3"
  >
    <span class="text-white">
      Desenvolvido com <span class="text-danger">❤</span> por
      <a href="https://wendelladriel.com" target="_blank">
        Wendell Adriel
      </a>
      <br />
      Gostou do jogo? Faça uma doação para contribuir:
      <br />
      <form action="https://www.paypal.com/donate" method="post" target="_top">
        <input type="hidden" name="hosted_button_id" value="HPE3LGMWM5JCJ" />
        <input
          type="image"
          src="https://www.paypalobjects.com/pt_BR/BR/i/btn/btn_donateCC_LG.gif"
          border="0"
          name="submit"
          title="PayPal - The safer, easier way to pay online!"
          alt="Donate with PayPal button"
        />
        <img
          alt=""
          border="0"
          src="https://www.paypal.com/pt_BR/i/scr/pixel.gif"
          width="1"
          height="1"
        />
      </form>
    </span>
  </footer>
</template>

<script>
export default {
  name: 'app-footer'
}
</script>

<style lang="sass" scoped>
footer
  background: #000
  color: #fff
  font-size: 1.2rem
  flex-shrink: 0
</style>
